// extracted by mini-css-extract-plugin
module.exports = {"ad":"sidebar-module__ad__1rGql"};